"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidCurrency = void 0;
const CademyError_1 = __importDefault(require("../../Domain/CademyError"));
class InvalidCurrency extends CademyError_1.default {
    constructor(detail, status, instance) {
        const type = `generic/invalid-currency`;
        super(type, 'Invalid Currency', detail, status, instance);
    }
}
exports.InvalidCurrency = InvalidCurrency;
exports.default = InvalidCurrency;
